import { KeyValue, KeyValuePipe } from '@angular/common';
import { booleanAttribute, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BaseInput, BootstrapSize, FieldsetInput } from './../../models';
import { FormControlsType } from './../../models/form';
import { FormInputComponent } from './../form-input/form-input.component';
import { FieldsetInputComponent } from './../inputs/fieldset-input/fieldset-input.component';

@Component({
	selector: 'app-form-inputs',
	templateUrl: './form-inputs.component.html',
	standalone: true,
	imports: [FieldsetInputComponent, FormInputComponent, KeyValuePipe]
})
export class FormInputsComponent {
	@Input({ transform: booleanAttribute }) filter: boolean;
	@Input() form: UntypedFormGroup;
	@Input() controls: FormControlsType;

	public keyvaluePipeCompareFn(
		a: KeyValue<string, BaseInput>,
		b: KeyValue<string, BaseInput>
	) {
		if (a.value.index > b.value.index) {
			return 1;
		}

		if (a.value.index < b.value.index) {
			return -1;
		}
		return 0;
	}

	/**
	 *
	 * @param size dimensione per griglia Bootstrap in diversi tipo dato
	 * @returns dimensione per griglia Bootstrap
	 * @see 20240715-FIXME
	 */
	public getBsClass(size: string | BootstrapSize): string {
		if (!size) {
			return 'col-12';
		}
		if ('string' === typeof size) {
			return BootstrapSize.formPipe(size).toClass();
		} else if (size instanceof BootstrapSize) {
			return size.toClass();
		}

		return 'col-12';
	}

	/**
	 *
	 * @param f value di elemento in Form.controls key|value
	 * @param p proprietà da testare in tipo dati BaseINput
	 * @returns proprietà se esiste o stringa vuota
	 * @see 20240717-FIXME
	 */
	public handleBaseInputProp = (
		f: BaseInput | FieldsetInput,
		p: string
	): string | BootstrapSize => (f instanceof BaseInput ? f[p] : '');

	/**
	 *
	 * @param f value di elemento in Form.controls key|value
	 * @returns oggetto di tipo FieldsetInput per FieldsetInputComponent
	 * @see 20240717-FIXME
	 */
	public handleFieldsetInputType = (
		f: BaseInput | FieldsetInput
	): FieldsetInput => (f instanceof FieldsetInput ? f : null);

	/**
	 *
	 * @param f value di elemento in Form.controls key|value
	 * @returns oggetto di tipo BaseInput per FormInputComponent
	 * @see 20240717-FIXME
	 */
	public handleBaseInputType = (f: BaseInput | FieldsetInput): BaseInput =>
		f instanceof BaseInput ? f : null;
}
